import React from 'react';
import { SignupForm } from '../../../components/SignupForm/SignupForm';

export const SignupPage: React.FC = () => {
  return <SignupForm />;
};
